import { render, staticRenderFns } from "./news_list.vue?vue&type=template&id=95d8bcf8"
import script from "./news_list.vue?vue&type=script&lang=js"
export * from "./news_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports